import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const PageWrapper = styled.div`
    min-height: 100vh;
    background: #111;
    color: var(--white);
    padding-bottom: 80px;
`;

// ─── Hero ─────────────────────────────────────────────────────────────────────

export const Hero = styled.div`
    position: relative;
    width: 100%;
    display: flex;
    align-items: flex-end;
    min-height: 420px;
    padding: 40px;
    box-sizing: border-box;
    background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: center;
        min-height: auto;
        padding: 30px 20px;
    }
`;

export const HeroOverlay = styled.div`
    position: absolute;
    inset: 0;
    background: linear-gradient(to top, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.3) 100%);
`;

export const ProfileImage = styled.img`
    position: relative;
    z-index: 1;
    width: 220px;
    height: 320px;
    object-fit: cover;
    border-radius: 16px;
    box-shadow: 0 20px 60px rgba(0,0,0,0.7);
    flex-shrink: 0;

    @media (max-width: 768px) {
        width: 160px;
        height: 240px;
    }
`;

export const HeroInfo = styled.div`
    position: relative;
    z-index: 1;
    margin-left: 40px;
    padding-bottom: 8px;

    @media (max-width: 768px) {
        margin-left: 0;
        margin-top: 20px;
        text-align: center;
    }
`;

export const ActorName = styled.h1`
    font-size: 3rem;
    font-weight: 800;
    color: #fff;
    margin: 0 0 12px;
    letter-spacing: -0.5px;

    @media (max-width: 768px) {
        font-size: 2rem;
    }
`;

export const KnownFor = styled.p`
    font-size: 1rem;
    color: rgba(255,255,255,0.6);
    margin: 0 0 16px;
    text-transform: uppercase;
    letter-spacing: 2px;
    font-size: 0.8rem;
    font-weight: 600;
`;

export const MetaRow = styled.div`
    display: flex;
    gap: 24px;
    flex-wrap: wrap;

    @media (max-width: 768px) {
        justify-content: center;
    }
`;

export const MetaItem = styled.div`
    display: flex;
    flex-direction: column;

    span:first-child {
        font-size: 0.72rem;
        font-weight: 700;
        letter-spacing: 1.5px;
        text-transform: uppercase;
        color: #fe88f1;
        margin-bottom: 4px;
    }

    span:last-child {
        font-size: 0.95rem;
        color: rgba(255,255,255,0.85);
    }
`;

// ─── Content ──────────────────────────────────────────────────────────────────

export const Content = styled.div`
    max-width: 1200px;
    margin: 0 auto;
    padding: 48px 24px 60px;
    background: #fff;
`;

export const SectionTitle = styled.h2`
    font-size: 1.2rem;
    font-weight: 700;
    color: #1a1a1a;
    margin: 0 0 20px;
    padding-bottom: 10px;
    border-bottom: 2px solid rgba(254, 136, 241, 0.5);
    text-transform: uppercase;
    letter-spacing: 2px;
`;

export const Bio = styled.p`
    font-size: 1rem;
    line-height: 1.8;
    color: #333;
    margin: 0 0 48px;
`;

// ─── Filmography Grid ─────────────────────────────────────────────────────────

export const FilmGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
    gap: 20px;

    @media (max-width: 480px) {
        grid-template-columns: repeat(3, 1fr);
        gap: 12px;
    }
`;

export const FilmCard = styled(Link)`
    display: block;
    text-decoration: none;
    border-radius: 10px;
    overflow: hidden;
    background: var(--darkGrey);
    transition: transform 0.2s ease, box-shadow 0.2s ease;

    &:hover {
        transform: translateY(-5px);
        box-shadow: 0 12px 30px rgba(0,0,0,0.6);
    }
`;

export const FilmPoster = styled.img`
    width: 100%;
    aspect-ratio: 2/3;
    object-fit: cover;
    display: block;
`;

export const FilmTitle = styled.p`
    font-size: 0.78rem;
    font-weight: 600;
    color: #222;
    padding: 8px;
    margin: 0;
    text-align: center;
    line-height: 1.3;
    background: #fff;
`;

// ─── Back Link ────────────────────────────────────────────────────────────────

export const BackLink = styled(Link)`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 0.85rem;
    font-weight: 600;
    color: #fe88f1;
    text-decoration: none;
    margin-bottom: 32px;
    transition: gap 0.2s ease;

    &::before { content: '←'; }
    &:hover { gap: 10px; }
`;
